export default __webpack_public_path__ + "static/media/stova-new-logo.a9dcb1fb.svg";